import $ from 'jquery';

$('.js-catalog-detail-faq-item').click(function () {
    $(this).toggleClass('catalog-detail-faq-item--active');
    $(this).find('.catalog-detail-faq-item__text').slideToggle();
});
